import $ from "jquery";

class Marquee {
    constructor(el) {
        this.el = el;
        this.$marquee = $(el);

        this.init();
    }

    init() {
        let dir = 'left';

        if (this.$marquee.data('dir')) {
            dir = this.$marquee.data('dir');
        }

        this.$marquee.marquee({
            duplicated: true,
            pauseOnHover: false,
            startVisible: true,
            direction: dir,
            delayBeforeStart: 0,
            speed: 50
        });

        this.$marquee.css('opacity', 1);
    }
}

export default Marquee;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/marquee.js